const settingsEn = {
    "settings": "Settings",
    "group_reservation": {
        "enable": "Enable group bookings",
        "show_on_page": "Show group booking page",
        "settings_title": "Group booking settings",
        "min_group_size": "Minimum group size",
        "max_group_size": "Maximum group size",
        "min_spending": "Minimum spending (HUF/person)",
        "max_spending": "Maximum spending (HUF/person)",
        "menu_link": "Menu link",
        "short_desc": "Short description",
        "long_desc": "Long description",
        "confirm_title": "Confirmation required",
        "confirm_text": "Please confirm that you have read and accepted the section on group bookings in the Terms and Conditions and acknowledge that after 2026.03.31 a booking fee applies to certain bookings as specified in the Terms and Conditions.",
        "accept": "Accept",
        "cancel": "Cancel"
    },
    "reservation_settings": {
        "title": "Reservation Settings",
        "reservation_system": "Reservation Settings",
        "reservation_availability": "Periodic Capacity Limits",
        "special_approval_rules": "Mandatory Approval Periods",
        "reservation_source": "Custom Reservation Source",
        "reservation_labels": "Labels",
        "reservation_fees": "Reservation Fees",
        "custom_questions": "Custom Questions",
        "reservation_length_rules": "Reservation Length Settings",
        "reservation_types": "Reservation Types",
        "group_offer_packages": "Group Packages",
        "guest_reviews": "Guest Reviews",
    },
    "guest_reviews": {
        "info_box": "When guest reviews are enabled, our system automatically sends a message to every guest one day after their visit.\nWith the Own message sending mode, you can set on this page which message the guest receives.\nWith the ReservOurs request mode, our system sends an email to guests, directing them to our review request page. Submitted reviews can later be tracked on our Statistics page.",
        "enable": "Enable guest reviews",
        "request_mode": "Review request method",
        "own_message": "Own message",
        "reservours": "ReservOurs",
        "review_structure": "Review structure",
        "simple": "Simple",
        "detailed": "Detailed",
        "review_structure_info_simple": "The guest rates their experience on a single 1-to-5 scale.",
        "review_structure_info_detailed": "The guest rates the food quality, service, and atmosphere separately, each on a 1-to-5 scale.",
        "text_review_enable": "Enable text review",
        "review_links_info": "After the internal review is submitted, we automatically show the guest the Google and Tripadvisor review links, if set.",
        "google_id": "Google ID",
        "google_id_helper": "Same as the value used in Google Reviews",
        "google_id_placeholder": "Enter the Google Business ID",
        "tripadvisor": "Tripadvisor link",
        "tripadvisor_placeholder": "Enter the Tripadvisor link",
    },
    "custom_questions": {
        "add_new": "Add New Question",
        "edit": "Edit Question",
        "question_text": "Question Text",
        "answer_options": "Answer Options",
        "add_answer": "Add Answer",
        "is_optional": "Optional question",
        "no_questions": "No custom questions yet. Add one to extend the booking flow.",
        "optional": "Optional",
        "required": "Required",
        "delete_confirm": "Are you sure you want to delete this question?",
        "question_type": "Question Type",
        "type_checkbox": "Checkbox",
        "type_dropdown": "Dropdown",
        "checkbox_hint": "The guest must check this during booking.",
    },
    "tables_and_rooms": {
        "title": "Tables and Rooms",
        "tables": "Table Order",
        "table_groups": "Table Groups",
        "rooms": "Rooms",
        "table_list_editor": "Table List",
        "room": "Room",
        "floorplan_designer": "Table Map",
        "show_on_group_reservation": "Show on group reservation page",
        "selected_room": "Edited room",
        "room_image": "Room image",
        "room_has_tables": "This room already has tables assigned to it, so it cannot be deleted.",
        "delete_room": "Delete room",
    },
    "opening_hours_and_blocks": {
        "title": "Opening Hours and Blocks",
        "blocked_times": "Block Hours",
        "room_blocks": "Block Rooms",
        "special_dates": "Block",
        "opening_hours": "Opening Hours",
        "shifts": "Shifts",
        "custom_opening_hours": "Custom Opening Hours",
        "service_break": "Service Break",
    },
    "account": {
        "title": "Account",
    },
    "messages": {
        "title": "Communication",
        "auto_messages": "Automatic messages",
        "custom_messages": "Custom messages",
        "internal_events": "Internal events",
        "reservation_messages": "Reservation interface message",
        "acceptance_texts": "Acceptable texts",
        "test_send": "Test send"
    },
    "restaurant_profile": {
        "title": "Restaurant Profile",
    },
    "restaurant_settings": {
        "title": "Restaurant settings",
        "reservours_info": "ReservOurs links",
        "restaurant_info": "Restaurant information",
        "restaurant_images": "Restaurant images",
        "google_reviews": "Google reviews",
        "tags": {
            "badacsony": "Badacsony",
            "balaton": "Balaton",
            "breakfast": "Breakfast",
            "brunch": "Brunch",
            "burger": "Burger",
            "business-lunch-and-dinner": "Business lunch and dinner",
            "cocktail": "Cocktail",
            "cozy": "Cozy",
            "craft-beer": "Craft beer",
            "deli-part": "Déli part",
            "dunakanyar": "Dunakanyar",
            "elegant": "Elegant",
            "eszaki-part": "Északi part",
            "family-lunch-and-dinner": "Family lunch and dinner",
            "gault-millau": "Gault&Millau",
            "michelin": "Michelin",
            "outdoor": "Outdoor",
            "party": "Party",
            "romantic": "Romantic",
            "wine-tasting": "Wine tasting",
            "street-kitchen": "Street kitchen",
            "vb2026": "Foci VB 2026 közvetítés"
        }
    },
    "integrations": {
        "title": "Integrations",
        "social_media": "Social Media",
        "analytics": "Analytics",
        "email_server": "Newsletter"
    },
    "users": {
        "title": "Users",
        "admins": "Admin users",
        "rights": "Rights"
    },
    "personal_settings": {
        "title": "Personal Settings",
        "language": "Language",
        "notifications": "Notifications",
        "billing_information": "Billing Information"
    },
    "miscellaneous": {
        "title": "Miscellaneous",
        "quickpick": "QuickPick QR Menu",
        "giftcards": "Gift Cards",
        "events": "Events",
        "experience_vouchers": "Experience Vouchers",
    },
    "exports": {
        "title": "Exports",
        "guest_database": "Exports",
        "guest_database_title": "Guest Database",
        "guest_database_desc": "Name, email address and phone number of all guests.",
        "newsletter_subscribers": "Newsletter Subscribers",
        "newsletter_subscribers_desc": "Name, email address and phone number of newsletter subscribers.",
        "reservations": "Reservations",
        "reservations_desc": "Reservations for the selected period (date, guest, size, source, comment).",
        "reservations_with_guests": "Reservations with Guest Data",
        "reservations_with_guests_desc": "Reservations with full guest data for the selected period.",
        "date_range": "Date Range",
        "download_xlsx": "Download (Excel)",
        "download_xls": "Download (Excel)",
        "download_csv": "Download (CSV)",
        "dining_city_import": "DiningCity Import",
        "dining_city_import_desc": "Import reservations from DiningCity (.xls format).",
        "select_file": "Select File",
        "import": "Import",
        "dining_city_import_success": "Import completed successfully.",
        "dining_city_import_error": "An error occurred during import. Please check the file.",
    },
    "exports_imports": {
        "title": "Exports / Imports",
    },
    "imports": {
        "title": "Imports",
        "dining_city": "DiningCity Import",
        "dining_city_import": "DiningCity Import",
        "guest_import_title": "Vendég import",
        "dining_city_import_desc": "Import reservations from DiningCity (.xls format).",
        "select_file": "Select File",
        "import": "Import",
        "dining_city_import_success": "Import completed successfully.",
        "dining_city_import_error": "An error occurred during import. Please check the file.",
        "dining_city_import_details": "Import details",
        "dining_city_import_info": "Reservation codes are stored in the notes of the created reservations. Updates needed during later imports are tracked based on the saved code and the guest's phone number, so please do not change these to ensure correct operation.",
        "guest_import": "Guest import",
        "guest_import_desc": "Import guests by attaching an .xlsx file",
        "guest_import_fields": "Expected column names for import",
        "field_desc": "Every sheet of the xlsx file is processed, regardless of its name. Guests already existing in the guest database (matched by phone number or email) are skipped. The order of columns does not matter, but if a column name is missing the import is aborted.",
        "guest_import_success": "Import completed successfully.",
        "guest_import_error": "An error occurred during import. Please check the file.",
        "required": "required",
        "optional": "optional"
    },
    "form_not_found": "Form not found",
    "form_loading": "Loading...",
    "reservation_system": {
        "size_settings": "Size settings",
        "max_restaurant_size": "Number of seats available",
        "size": "size (persons)",
        "minimum_reservation_length": "Minimum reservation length",
        "maximum_reservation_length": "Maximum reservation length",
        "last_reservation_for_the_day": "Last reservation for today",
        "min_reservation_timeframe": "Minimum reservation time frame",
        "automatic_approval_from": "Automatic approval",
        "max_number_of_guests": "Max. group size",
        "max_guests_at_time": "Max. number of guests",
        "privacy_policy": "Redirect after reservation",
        "turnaround_time": "Guest turnaround time",
        "reserve_time_minutes": "Reservation grace period (minutes)",
        "max_reservation_timeframe": "Reservation time frame (months)",
        "automatic_seating": "Automatic guest seating",
        "max_online_fill_rate": "Capacity for walkins (%)",
        "enable_online_reservations": "Enable online reservations",
        "enable_sms": "Enable SMS messages (billed per SMS per month)",
        "enable_quarterly_hours": "Reservation times every quarter hour",
        "enable_waiting_list": "Enable waiting list",
        "enable_custom_length_step": "Reservation length in 15-minute steps (admin only)",
        "reservours_reservations": "Show on listing site",
        "enable_group_reservation": "Enable group reservations",
        "default_reservation_length": "Default reservation length",
        "allow_reservation_modification": "Allow modification by guest",
        "reservation_change_timeframe": "Modifiable until this many hours before the reservation (hours)",
        "allow_reservation_modification_info": [
            {
                "title": "Where can the guest edit their reservation?",
                "items": [
                    "In the confirmation message sent to the guest's email after booking"
                ]
            },
            {
                "title": "When can the guest edit a submitted reservation?",
                "items": [
                    "If the reservation is not deleted or marked as arrived",
                    "If there is enough time left before the reserved time (configurable below the checkbox)",
                    "If there is no reservation fee attached to the reservation"
                ]
            },
            {
                "title": "What happens if a reservation we have already approved is modified?",
                "items": [
                    "All rules that apply to reservations in general (such as automatic approval, table assignment, or the advance booking timeframe) are automatically applied to the modified reservation."
                ]
            },
            {
                "title": "Can I track what changes the guest made?",
                "items": [
                    "If a guest modifies a reservation, the 'Modifications' tab on the reservation editor shows when and what was changed, so the reservation's previous state can be looked up."
                ]
            }
        ],
    },
    "reservation_types": {
        "page_title": "Reservation Types",
        "info": "The name of 'inside' and 'outside' types cannot be changed. All other fields are editable. Every row is sent to the server on save.",
        "name": "Name",
        "size": "Capacity",
        "priority": "Priority",
        "allcount": "Allcount",
        "approval_from": "Approval from",
        "available": "Available",
        "min_spending": "Min. spending",
        "min_spending_from": "Min. spending from",
        "min_reservation_size": "Min. guests",
        "max_reservation_size": "Max. guests",
        "available_from": "Available from",
        "available_to": "Available to",
        "add_type": "Add type",
        "save_success": "Reservation types saved successfully.",
        "error_name_required": "Name is required for every row.",
    },
    "reservation_length_rules": {
        "page_title": "Reservation length settings",
        "title": "Custom reservation length rules",
        "default_row_label": "Default",
        "add_rule": "Add custom rule",
        "guest_range_min": "Min guests",
        "guest_range_max": "Max guests",
        "default_length": "Default length",
        "min_length": "Min length",
        "max_length": "Max length",
        "minutes_suffix": "min",
        "info": "By default all reservations use the lengths defined in the Default row. Custom rules let you override these lengths based on the number of guests. When a reservation's guest count falls within a rule's range, that rule's lengths are applied instead of the defaults.",
        "invalid_row_values": "Some rows have invalid values: min guests cannot exceed max guests, and reservation lengths must satisfy min ≤ default ≤ max.",
        "overlapping_guest_ranges": "Some rows have overlapping guest ranges. Please fix the conflicts before saving.",
        "save_success": "Reservation length settings saved successfully.",
    },
    "reservation_availability": {
        "add_new_custom_max_fill_rate": "Add new custom max fill rate",
        "hour_from": "From hour",
        "hour_to": "To hour (inclusive)",
        "max_fill_rate": "Max fill rate (%)",
        "valid_from": "Validity start",
        "valid_to": "Validity end",
        "delete_fill_rate": "Delete max fill rate",
        "delete_fill_rate_confirmation": "Are you sure you want to delete this max fill rate?",
        "edit_fill_rates": "Edit max fill rates",
        "edit_fill_rate": "Edit max fill rate",
    },
    "special_approval_rules": {
        "info": "Reservations falling into these periods are never approved automatically, they always have to be accepted manually. The period applies to the start time of the reservation. The guest count means that manual approval is required from at least this many guests (0 applies to every reservation).",
        "add_new": "Add new period",
        "existing_rules": "Configured periods",
        "date_from": "Period start",
        "date_to": "Period end",
        "from_size": "From guest count",
        "delete_rule": "Delete period",
        "delete_rule_confirmation": "Are you sure you want to delete this period? ({{from}} - {{to}})",
    },
    "reservation_source": {
        "add_new_custom_source": "Add new custom source",
        "source_name": "Source name",
        "delete_source": "Delete source",
        "delete_source_confirmation": "Are you sure you want to delete this source?",
    },
    "reservation_background": {
        "image_in_reservation_background": "This image will be displayed in the background of the reservation interface",
    },
    "auto_messages": {
        "message_type": "Message type",
        "message": "Message",
        "placeholder_tags": "Variables: {guest_name}, {reservation_date}, {reservation_start}, {reservation_end}, {reservation_size}, {reservation_type}. Variables used must contain {} brackets.",
        "confirm": "Confirmed",
        "pending": "Pending, pending approval",
        "approve": "Admin - Approve",
        "decline": "Admin - Decline",
        "delete": "Admin - Delete",
        "review": "Request review",
        "self_delete": "Guest cancelled their reservation",
        "sms": "SMS",
        "min_date_warning_message": "Minimum date warning message",
        "no_timeslots_available_message": "No timeslots available message",
        "ai_generate": {
            "title": "Generate with AI",
            "style_label": "Style",
            "generate_button": "Generate",
            "generating": "Generating...",
            "overwrite_confirm": "This will overwrite the current message. Continue?",
            "styles": {
                "formal": "Formal",
                "informal": "Informal",
                "elegant": "Elegant",
                "casual": "Casual",
                "warm": "Warm & Personal",
                "professional": "Professional",
                "luxury": "Luxury",
                "concise": "Concise"
            }
        }
    },
    "internal_events": {
        "message": "Message",
    },
    "custom_messages": {
        "date": "Date",
        "type": "Type",
        "message": "Message",
        "delete_message": "Delete message",
        "delete_message_confirmation": "Are you sure you want to delete this message?",
    },
    "acceptance_text": {
        "message": "Message text",
        "acceptance_text_tip_title": "What are acceptance texts?",
        "acceptance_text_tip_text": "Acceptance texts are messages that guests must accept before completing their reservation. These messages may contain important information, rules, or conditions that guests need to acknowledge before booking.",
        "how_to_delete": 'You can delete already created "Acceptance texts" under Messages -> Custom messages, which are displayed as "special" type.',
        "edit_acceptance_text": "Elfogadandó szöveg szerkesztése",
        "add_acceptance_text": "Elfogadandó szöveg hozzáadása"
    },
    "test_send": {
        "email_to_receive": "Test emails are sent to the logged-in user's email address.",
        "automatic_acceptance": "Automatic acceptance",
        "automatic_pending": "Recorded, waiting for approval",
        "automatic_confirm": "Approval",
        "admin_decline": "Admin - Decline",
        "admin_delete": "Admin - Delete",
        "review_request": "Request review",
        "self_delete": "Guest cancelled their reservation",
        "description": "If no custom message is set, no test message will be sent.",
        "test_send_success": "Test message sent successfully",
    },
    "reservours_info": {
        "reservours_link": "Restaurant Reservours Link",
        "booking_link_for_website": "Booking link for website",
        "booking_link_for_facebook": "Booking link for Facebook",
        "booking_link_for_google": "Booking link for Google",
    },
    "restaurant_info": {
        "name": "Name",
        "telephone": "Telephone",
        "email": "Email",
        "country": "Country",
        "city": "City",
        "postal_code": "Postal code",
        "address": "Address",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "click_on_the_map": "Click on the map for exact coordinates",
        "type": "Type",
        "category": "Category",
        "price_category": "Price category",
        "tags": "Tags",
        "website": "Website",
        "menu_url": "Menu link",
        "facebook_link": "Facebook link",
        "instagram_link": "Instagram link",
        "foodora_link": "Foodora link",
        "wolt_link": "Wolt link",
        "quickpick_link": "QuickPick link",
        "motto": "Motto/Slogan",
        "long_description": "Long description",
        "specialties": "Specialties",
        "specialty": {
            "breakfast": "Breakfast",
            "coffee": "Coffee",
            "dinner": "Dinner",
            "drinks": "Drinks",
            "lunch": "Lunch",
            "delivery": "Delivery",
            "catering": "Catering",
            "groups": "Groups",
            "kids": "Children",
            "outdoor": "Outdoor",
            "reserve": "Reservation",
            "takeout": "Takeout",
            "waiter": "Waiter",
            "walkins": "Walk-in",
        },
        "types": {
            "restaurant": "Restaurant",
            "cafe": "Café",
            "bar": "Bar",
        },
        "bg": "Background",
        "restaurantimage": "Restaurant image",
        "voucher_background": "Voucher background",
        "voucher_logo": "Voucher logo",
        "delete_image": "Delete image",
        "image_delete_confirm": "Are you sure you want to delete this image?",
    },
    "social_media": {
        "no_available_channels": "No channels available",
        "integration_fee": "More details about fees related to social media integrations in the GTC: ",
        "integration_guide": "Installation help for Meta integrations in the Knowledge Base: ",
        "query_integration_credentials": "Get login details for Meta integration",
        "meta_credentials": "Meta ",
    },
    "analytics": {
        "code": "Code",
        "google_analytics_id": "Google Analytics Measurement ID",
        "facebook_pixel_id": "Facebook Pixel ID",
        "tiktok_pixel_id": "TikTok Pixel ID",
        "google_tag_manager_id": "Google Tag Manager ID",
        "tag_manager_disclaimer": "According to the partner terms and conditions, only Facebook Pixel, Google Analytics, and TikTok Pixel may be placed through Tag Manager. In case of violation, the partner bears full responsibility for any damages arising from GDPR non-compliance.",
        "average_basket_value": "Average basket value (Ft)",
    },
    "email_server": {
        "mailchimp": "Mailchimp",
        "api_key": "API key",
        "api_key_instructions": "To find your API key, please follow this link: https://mailchimp.com/help/about-api-keys/",
        "marketing_email_policy": "Marketing email policy link",
        "mandatory_for_mailchimp": "Mandatory for Mailchimp",
        "select_mailing_list": "Select a mailing list",
        "mailerlite": "MailerLite",
        "mailerlite_api_key_instructions": "Find your API key in your MailerLite account under Integrations → API.",
        "mailerlite_list_id_label": "Group ID",
        "mailerlite_list_id_instructions": "Find the group ID in MailerLite under Subscribers → Groups.",
        "brevo": "Brevo",
        "brevo_api_key_instructions": "Find your API key in your Brevo account under Settings → API Keys.",
        "brevo_list_id_label": "List ID",
        "brevo_list_id_instructions": "Find the list ID next to the list name in the Brevo admin (numeric value).",
    },
    "admins": {
        "admin_users": "Admin users",
        "add_new_admin": "Add new admin",
        "email": "Email",
        "name": "Name",
        "avatar": "Image",
        "is_admin": "Are you an admin?",
        "email_verified": "Account activated?",
        "right_type": "Permission",
        "delete_admin": "Delete Admin",
        "delete_admin_confirmation": "Are you sure you want to delete this administrator?",
        "rights": {
            "admin": "Administrator",
            "reservations_only": "Reservations edit only",
            "view_only": "Reservation view only",
            "reservations_and_settings": "Reservations and settings edit",
        }
    },
    "notifications": {
        "guest_reservation": "Notification of a guest reservation",
        "admin_add_reservation": "Notification of a reservation added in the admin interface",
        "admin_delete_reservation": "Notification of a reservation deleted in the admin interface",
        "admin_cancel_reservation": "Notification of a reservation rejected in the admin interface",
        "data_autorefresh": "Automatically refresh data every 5 minutes",
        "newsletter": "Subscribe to newsletter",
        "monthly_summary": "Receive monthly summary",
    },
    "blocked_times": {
        "valid_from": "Validity start",
        "valid_to": "Validity end",
        "type": {
            'blocked': 'Blocked',
            'closed': 'Closed',
        },
        'new_blocked_time': 'Add new block',
        'day': 'Day',
        'blocked_description': 'The start of the reservation cannot fall within the blocked period, during the blocked period the user will see that the catering establishment, but there are no vacancies.',
        'closed_description': 'Neither the start nor the end of the booking can fall within the blocked period.',
        'additional_description': 'If you want to be closed for the whole day, the closed period should start before 11:00 and end after 21:00!',
        'delete_blocked_time': 'Delete block',
        'delete_blocked_time_confirmation': 'Are you sure you want to delete this block?',
        "add_new_blocked_time": "Add new block",
        "edit_blocked_time": "Edit block",
    },
    "shifts": {
        "new_shift": "Add new shift",
        "name": "Name",
        "lunch": "Lunch",
        "from": "Start",
        "to": "End",
        "interval": "Duration",
        "max_guests": "Max allowed guest percentage",
        "delete_shift": "Delete shift",
        "delete_shift_confirmation": "Are you sure you want to delete this shift?",
        "overlapping_shift": "The shifts are overlapping, please check your settings!",
    },
    "room_blocks": {
        "name": "Name",
        "block_from": "Start date",
        "block_time": "Start time",
        "room": "Room",
        "block_length": "Block length",
        "time_blocks": "Time block",
        "date_blocks": "Date block",
        "description": "If a room is blocked, it will appear as a reservation in the reservation list, it is not listed separately here!",
        "max_range_warning": "The date interval can be at most 1 week.",
    },
    "opening_hours": {
        "opening_interval": "Opening time window",
        "reservation_interval": "Reservation time window",
        "valid_interval": "Validity time window",
        "validation": {
            "reservation_from_before_open_from": "Error for {{weekday}}: Reservation start time ({{reservationFrom}}) cannot be earlier than opening time ({{openFrom}}).",
            "reservation_from_after_open_to": "Error for {{weekday}}: Reservation start time ({{reservationFrom}}) cannot be at or after closing time ({{openTo}}).",
            "reservation_to_not_after_open_from": "Error for {{weekday}}: Reservation end time ({{reservationTo}}) cannot be at or before opening time ({{openFrom}}).",
            "reservation_to_after_open_to": "Error for {{weekday}}: Reservation end time ({{reservationTo}}) cannot be at or after closing time ({{openTo}}).",
            "reservation_interval_invalid": "Error for {{weekday}}: Reservation start time ({{reservationFrom}}) cannot be the same as or later than the end time ({{reservationTo}}).",
            "reservation_to_after_midnight": "Error for {{weekday}}: Reservation end time ({{reservationTo}}) cannot be at or after midnight.",
            "overlap_error": "Error for {{weekday}}: Overlap between entries valid from {{validFrom1}} - {{validTo1}} ({{timeRange1}}) and {{validFrom2}} - {{validTo2}} ({{timeRange2}}) ({{overlapType}}).",
            "overlap_type_open": "Opening times",
            "overlap_type_reservation": "Reservation times"
        },
        "custom_hours_note": "In case of custom opening hours, the existing opening hours will be overwritten on the selected days. The modification cannot be undone!",
        "service_break_note": "In the event of a service break, we will insert a break into the existing opening hours, during which the restaurant is unavailable and cannot be booked. The modification cannot be undone!",
        "service_break_timerange": "Service break time interval",
        "custom_hour_saved": "Custom opening hours saved successfully. You can check the result of the change under the Opening hours settings menu.",
        "service_break_saved": "Service break saved successfully. You can check the result of the change under the Opening hours settings menu.",
    },
    "rooms": {
        "room_name": "Room name",
        "priority": "Priority",
        "add_room": "Add room",
        "priority_duplicate": "Priority duplication",
    },
    "giftcards": {
        "giftcards_url": "Gift card link",
        "min_value": "Minimum value (Ft)",
        "max_value": "Maximum value (Ft)",
        "step": "Step",
        "bg_color": "Background color",
        "text_color": "Text color",
        "enable_sales": "Enable sales",
        "logo_url": "Logo image",
        "bg_image_url": "Background image",
        "valid_for_days": "Validity in days",
        "description": "Description",
        "experience_voucher_title": "Edit Experience Voucher",
        "voucher_name": "Voucher Name",
        "value": "Value (Ft)",
        "active": "Active",
        "experience_vouchers_title": "Experience Vouchers",
        "delete_experience_voucher": "Are you sure you want to delete this experience voucher?",
        "experience_voucher_deleted": "Experience voucher successfully deleted",
        "no_experience_vouchers_yet": "No experience vouchers have been created yet"
    },
    "events": {
        "event_url": "Event link",
    },
    "billing": {
        "name": "Company name",
        "tax_code": "Tax code",
        "emails": "Email addresses",
        "post_code": "Postal code",
        "city": "City",
        "address": "Address",
        "email_description": "Addresses should be separated by commas",
        "info1": "Warning: By changing the billing information, the next month's billing will be based on the provided data.",
        "info2": "ReservOurs always bills retrospectively, so only change the company data after the change takes effect.",
        "billing_default_country": "Default country is Hungary",
        "country": "Country"
    },
    "labels": {
        "own_labels": "Own labels",
        "global_labels": "Global labels",
        "preview": "Preview",
        "priority": "Priority",
        "color": "Color",
        "text": "Text",
        "scope": "Scope",
        "add_label": "Create new label",
        "visibility": "Visibility",
        "order": "Order",
        "label_added": "New label successfully added to the list. Don't forget to save after sorting!",
        "label_scope": {
            "ALL": "All",
            "RESERVATION": "Reservation",
            "GUEST": "Guest",
        }
    },
    "tables": {
        "table_name": "Table name",
        "table_size": "Table size",
        "table_type": "Table type",
        "fulfilling_order": "Filling order",
        "display_order": "Display order",
        "table_order_saved": "New table order saved successfully",
    },
    "table_groups": {
        "available_tables": "Available tables",
        "grouped_tables": "Grouped tables",
        "drop_tables_here": "Drag the available tables you want to group here",
        "save_group": "Create new group",
        "table_group_name": "Table names",
        "table_group_size": "Maximum size",
        "min_size": "Minimum size",
        "delete_group": "Delete group",
        "no_groups": "There are no groups to display",
        "info_message": "You can change the maximum size to give your grouped tables custom sizes. They will appear with a yellow background.",
    },
    "google_reviews": {
        "search_google_business_by_name": "Search by name",
        "google_business_id": "Google Business ID",
        "google_business_id_placeholder": "Enter Google Business ID",
        "refresh_reviews": "Refresh reviews",
        "save_and_refresh": "Save and refresh reviews",
        "saved": "New Google Business ID successfully saved! New reviews loaded.",
        "refreshed": "New reviews successfully loaded!",
        "no_results": "No results",
    },
    "payments": {
        "refund": "Refund",
    },
    "payment_schemes": {
        "info": "Reservation fees define whether the guest has to pay when booking. Editing does not overwrite the existing fee: the old one is inactivated and a new row is created - so reservations already made keep their original fee and cancellation deadline.",
        "new_scheme": "New reservation fee",
        "edit_scheme": "Edit reservation fee",
        "terms_accept_new": "I have read and accept the provisions of the Partner Terms and Conditions concerning reservation fees.",
        "terms_info_new": "I acknowledge that the conditions and costs of charging, cancelling and refunding the reservation fee are set out in the Partner Terms and Conditions, and that the fee set here applies to reservations made after saving.",
        "terms_accept_edit": "I accept the consequences of this change and the provisions of the Partner Terms and Conditions concerning reservation fees.",
        "terms_info_edit": "I acknowledge that saving inactivates the current fee and creates a new one: reservations already made keep the previous fee and cancellation deadline, and the change only affects reservations made from now on. The costs and conditions of reservation fees are set out in the Partner Terms and Conditions.",
        "terms_link": "Partner Terms and Conditions",
        "scheme_saved": "Reservation fee saved",
        "scheme_not_found": "This reservation fee no longer exists, the list has been reloaded.",
        "show_inactive": "Show inactive fees",
        "reservation_type": "Reservation type",
        "default_type": "Default (all types)",
        "validity": "Validity",
        "valid_from": "Valid from (reservation date)",
        "valid_to": "Valid to",
        "valid_to_exclusive": "The end is exclusive: the given moment is already outside the validity.",
        "from_reservation_size": "Guest count from",
        "to_reservation_size": "Guest count to",
        "fee": "Fee",
        "fee_type": "Fee type",
        "fee_type_per_guest": "Per guest",
        "fee_type_fixed": "Fixed amount",
        "fee_amount_per_guest": "Fee amount (per guest)",
        "fee_amount_fixed": "Fee amount (whole reservation)",
        "fee_per_guest_value": "{{amount}} {{currency}} / guest",
        "fee_fixed_value": "{{amount}} {{currency}} / reservation (fixed)",
        "cancellation": "Cancellation",
        "refund_scheme": "Cancellation scheme",
        "refund_scheme_label": "{{hours}} hours before the reservation",
        "currency": "Currency",
        "payment_type": "Payment method",
        "payment_types": {
            "immediate": "Immediate payment"
        },
        "active": "Active",
        "priority_helper": "If several overlapping fees match a reservation, the one with the lower priority applies.",
        "conflict_warning": "Warning: the fees below overlap with the same priority, so it is not determined which one applies. You can still save.",
        "error_valid_to": "The end of validity must be later than its start.",
        "error_from_reservation_size": "The lower guest count limit must be at least 1.",
        "error_to_reservation_size": "The upper guest count limit cannot be smaller than the lower one.",
        "error_fee_per_guest": "The fee cannot be negative and must be a whole number.",
        "error_priority": "The priority cannot be negative and must be a whole number.",
        "hours_from_reservation": "Hours from reservation",
        "reservation_size": "Reservation size",
        "priority": "Priority",
        "fee_per_guest": "Fee per guest",
        "fixed_price": "Fixed price",
        "refund_percentage": "Refund percentage",
        "reservation_fee_inactivation": "Reservation fee inactivation",
        "reservation_fee_confirmation": "Inactivate this reservation fee? It will not apply to reservations made from now on, existing reservations are unchanged.",
    },
    "attributes": {
        "attributes": "Attributes",
        "categories": {
            "technology": "Technology",
            "payment": "Payment",
            "experience": "Experience",
            "events": "Events",
            "opening_hours": "Opening hours",
            "safety": "Safety",
            "sustainability": "Sustainability",
            "location": "Location",
            "services": "Services",
            "food_options": "Food options",
            "drink_options": "Drink options",
            "accessibility": "Accessibility",
        },
        "items": {
            "downtown": "Downtown location",
            "waterfront": "Waterfront / lakeside / seaside",
            "near_public_transport": "Easily accessible by public transport",
            "wheelchair_accessible": "Wheelchair accessible",
            "pet_friendly": "Pet friendly",
            "child_friendly": "Child friendly",
            "terrace": "Terrace / garden area",
            "smoking_area": "Smoking area",
            "air_conditioning": "Air conditioning",
            "private_room": "Private event room",
            "takeaway": "Available for takeaway",
            "delivery": "Home delivery",
            "vegetarian": "Vegetarian options",
            "vegan": "Vegan options",
            "gluten_free": "Gluten-free options",
            "halal": "Halal food",
            "organic": "Organic food",
            "local_ingredients": "Local ingredients",
            "craft_beer": "Craft beers",
            "wine_selection": "Wine selection",
            "cocktails": "Cocktails",
            "coffee_specialty": "Coffee specialties",
            "non_alcoholic": "Non-alcoholic drinks",
            "online_reservation": "Online reservation",
            "qr_menu": "QR code menu",
            "wifi": "Free WiFi",
            "mobile_payment": "Mobile payment at the table",
            "contactless_payment": "Contactless payment",
            "card_payment": "Card payment",
            "szep_card": "SZÉP card acceptance",
            "foreign_currency": "Foreign currency acceptance",
            "amex": "American Express acceptance",
            "live_music": "Live music",
            "karaoke": "Karaoke",
            "sports_screen": "Sports screening",
            "dance_floor": "Dance floor/party venue",
            "view": "Panoramic view",
            "wedding": "Wedding venue",
            "business_meetings": "Business meetings",
            "birthday": "Birthday programs",
            "themed_nights": "Themed nights",
            "open_24h": "Open 0-24",
            "late_night": "Late night opening hours",
            "seasonal": "Seasonal opening hours",
            "holiday_open": "Open on holidays",
            "non_smoking": "Non-smoking",
            "allergen_info": "Allergen information display",
            "air_filters": "Air filter usage",
            "covid_measures": "COVID-19 safety measures",
            "eco_friendly": "Sustainable operation",
            "recyclable_packaging": "Recyclable packaging",
            "food_waste_policy": "Food waste reduction",
        }
    }
}

export default settingsEn;